export enum BuildStatus {
	Reverted = 'reverted',
	Build = 'build',
	Pending = 'pending',
}
